import BannerInicial from './BannerInicial';

export default BannerInicial;
